import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from '@/App'
import { queryClient } from '@/lib/query-client'
// The two brand faces, matching acasaimmobilien.de. The variable package ships
// one @font-face per unicode-range, so only the latin file is ever downloaded.
import '@fontsource-variable/wix-madefor-display/wght.css'
import '@fontsource/libre-caslon-text/latin-400.css'
// Functional faces: aligned identifiers, and condensed for the rotated matrix
// headers. latin subsets only — German needs no cyrillic/greek/vietnamese.
import '@fontsource/ibm-plex-mono/latin-400.css'
import '@fontsource/ibm-plex-mono/latin-500.css'
import '@fontsource/ibm-plex-sans-condensed/latin-500.css'
import '@/index.css'

const container = document.getElementById('root')

if (!container) {
  throw new Error('#root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
